// #region CONSTANTES
export const URL = "https://apiionycar.netbase.fr";
export const RESSOURCE_AUTHENTIFICATION = "authentication_token";
// #endregion
